import { InputSearchProps } from '../../../types/InputSearch';
import { FiSearchIcon } from '../../Icon';

import styles from './InputSearch.module.scss';

import type { FC } from 'react';

export const InputSearch: FC<InputSearchProps> = ({
  placeholder,
  value,
  onChange,
}) => (
  <div className={styles['input-search-wide']}>
    <input
      className={styles['input-inner-text']}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      type="text"
    />
    <span className={styles['input-inner-button']}>
      <span className={styles['input-inner-button-icon']}>
        <FiSearchIcon size={24} />
      </span>

      <input
        className={styles['input-inner-button-submit']}
        value={value}
        type="submit"
      />
    </span>
  </div>
);
